import { gql } from '@apollo/client';

export const sendNextStepsEmail_Name = 'SendNextStepsEmail';
export const sendNextStepsEmail_Gql = gql`
  mutation SendNextStepsEmail($emailData: SendNextStepsEmailInput!) {
    sendNextStepsEmail(emailData: $emailData)
  }
`;
